import HudTimer from 'app/ui/hud/HudTimer';
import HudButtons from 'app/ui/hud/HudButtons';
import HudGameIntro from 'app/ui/hud/HudGameIntro';
import HudGamePlay from 'app/ui/hud/HudGamePlay';
import HudHowToPlay from 'app/ui/hud/HudHowToPlay';
import HudLevelWin from 'app/ui/hud/HudLevelWin';
import HudLevelFail from 'app/ui/hud/HudLevelFail';
import HudGamePause from 'app/ui/hud/HudGamePause';
import HudGameCredits from 'app/ui/hud/HudGameCredits';
import HudRotateScreen from 'app/ui/hud/HudRotateScreen';
import * as AppTrackingEvents from 'app/constants/AppTrackingEvents';

import { STATE_WELCOME, STATE_BOOT } from 'app/constants/AppConstants';

class Hud extends Phaser.Group {
  constructor(game) {
    super(game);
    this.previousStates = [];
    this.state = null;
    this.enabled = false;
    this.active = true;
    this.visible = false;
    this.screenIsRotated = false;
    this.alpha = 0;
    this.bindedHandleButtonInteraction = this.handleButtonInteraction.bind(this);
  }

  init(buttonsConfig) {
    this.hudButtons = new HudButtons(this.game);
    this.hudButtons.init(buttonsConfig);
    // this.timer = new HudTimer({ game: this.game, sheet: 'ui' });
    // this.add(this.timer);
    // this.timer.visible = false;
    this.createModal();
    this.add(this.hudButtons);
    this.sendToBack(this.hudButtons);
    this.enable();
  }

  fadeIn() {
    this.alpha = 0;
    this.visible = true;
    this.game.add
      .tween(this)
      .to({ alpha: 1 }, 250)
      .start();
  }

  isWelcomeScreen() {
    return this.state === null || this.state.id === Hud.WELCOME;
  }

  setScreenIsRotated(val) {
    this.screenIsRotated = val;
  }

  show() {
    this.visible = true;
  }

  hide() {
    this.visible = true;
  }

  enable() {
    this.enabled = true;
  }

  disable() {
    this.enabled = false;
  }

  activate({ id = Hud.PLAYING, isModal = false }) {
    // console.log('Hud.activate', id);
    const numberOfChildren = this.game.stage.children.length;
    const childIndex = this.screenIsRotated ? numberOfChildren - 2 : numberOfChildren - 1;
    this.game.stage.addChildAt(this, childIndex);
    this.active = true;
    this.configure({ id, isModal });
    this.visible = true;
    this.game.scale.onSizeChange.add(this.positionElements, this);
  }

  deactivate() {
    this.reset();
    this.active = false;
    this.visible = false;
    this.game.scale.onSizeChange.remove(this.positionElements, this);
    this.game.stage.removeChild(this);
  }

  configure({ id = Hud.PLAYING, isModal = false, isVisible = true }) {
    // console.log('Hud.configure', id, isModal);
    this.saveState(this.state);
    this.state = { id, isModal };
    // id === Hud.PLAYING || id === Hud.PAUSE || id === Hud.CREDITS ? this.showTimer() : this.hideTimer();
    const opts = Hud.STATES[this.state.id];
    this.hudButtons.renderButtons(opts, this.bindedHandleButtonInteraction);
    this.showModal(this.state.isModal);
    this.visible = isVisible;
    this.positionElements();
  }

  reset() {
    this.state = null;
    this.previousStates = [];
  }

  createModal() {
    // this.modalBG = this.game.make.image(0, 0, 'bg_fade');
    // this.modalBG.anchor.set(0, 0);
    // this.add(this.modalBG);
    // this.modalBG.visible = false;
  }

  showModal(isVisible) {
    // this.modalBG.visible = isVisible;
  }

  /*
  ======================================================================================================
    LEVEL END
  ======================================================================================================
  */

  showLevelWin({ isLastLevel }) {
    this.levelEnd = new HudLevelWin({
      game: this.game,
      isLastLevel,
    });
    this.add(this.levelEnd);
  }

  showLevelFail({ totalLevelScore, newGameScore, collectTarget }) {
    this.levelEnd = new HudLevelFail({
      game: this.game,
      totalLevelScore,
      newGameScore,
      collectTarget,
    });

    this.add(this.levelEnd);
  }

  closeLevelEnd() {
    if (this.levelEnd) {
      this.levelEnd.destroy();
    }
  }

  /*
  ======================================================================================================
    PAUSE / RESUME
  ======================================================================================================
  */

  showGamePause() {
    this.hudGamePause = new HudGamePause({ game: this.game });
    this.addChild(this.hudGamePause);
  }

  closeGamePause() {
    if (this.hudGamePause) {
      this.hudGamePause.destroy(true);
    }
  }

  showGameIntro(onClose, onCloseScope) {
    this.gameIntro = new HudGameIntro({ game: this.game, onClose, onCloseScope });
    this.add(this.gameIntro);
  }

  showGameIntroMessage(message, onClose, onCloseScope) {
    this.gameIntro = new HudGameIntro({ game: this.game, message, onClose, onCloseScope });
    this.add(this.gameIntro);
  }

  closeGameIntro() {
    if (this.gameIntro) {
      this.gameIntro.destroy();
    }
  }

  showRotateScreen() {
    if (!this.hudRotateScreen) {
      if (this.game.state.current !== STATE_BOOT) {
        this.hudRotateScreen = new HudRotateScreen({ game: this.game });
        this.addChild(this.hudRotateScreen);
      }
    }
  }

  closeRotateScreen() {
    if (this.hudRotateScreen) {
      if (this.game.state.current === STATE_WELCOME) {
        this.game.controller.gamePaused = false;
      }
      if (this.game.state.current !== STATE_BOOT) {
        this.hudRotateScreen.destroy(true);
        this.hudRotateScreen = null;
      }
    }
  }

  /*
  ======================================================================================================
    CREDITS
  ======================================================================================================
  */

  showGameCredits() {
    this.hudGameCredits = new HudGameCredits({ game: this.game });
    this.add(this.hudGameCredits);
  }

  closeGameCredits() {
    if (this.hudGameCredits) {
      this.hudGameCredits.destroy(true);
    }
  }

  showGamePlayHud(levelData) {
    if (!this.gamePlayHud) {
      this.gamePlayHud = new HudGamePlay({ game: this.game, levelData });
      this.addAt(this.gamePlayHud, 0);
    }
  }

  hideGamePlayHud() {
    if (this.gamePlayHud) {
      this.gamePlayHud.destroy();
      this.gamePlayHud = null;
    }
  }

  updateGamePlayHud(time, score) {
    if (this.gamePlayHud) {
      this.gamePlayHud.updateStats(time, score);
    }
  }

  showInstructions() {
    if (!this.gameInstructions) {
      this.gameInstructions = new HudHowToPlay({ game: this.game });
      this.gameInstructions.onClose.add(this.handleInstructionClose, this);
      this.add(this.gameInstructions);
    }
  }

  handleInstructionClose() {
    this.gameInstructions.onClose.remove(this.handleInstructionClose, this);
    this.gameInstructions = null;
  }

  /*
  ====================================================================================
    TIMER
  ====================================================================================
  */

  updateTimeProgress(value) {
    // this.timer.setTime(value);
  }

  showTimer() {
    // this.timer.visible = true;
  }

  hideTimer() {
    // this.timer.visible = false;
  }

  /*
  ====================================================================================
    LAYOUT
  ====================================================================================
  */
  positionElements() {
    const paddingX = this.game.screenPaddingX;
    const paddingY = this.game.screenPaddingY;
    this.hudButtons.positionButtonGroups(paddingX, paddingY);
    if (this.modalBG) {
      this.modalBG.width = this.game.width;
      this.modalBG.height = this.game.height;
      this.modalBG.position.set(0);
    }
    if (this.timer) {
      this.timer.position.set((this.game.width - this.timer.width) * 0.5, paddingY);
    }
  }

  /*
  ====================================================================================
    BUTTON INPUT
  ====================================================================================
  */
  handleButtonInteraction(e) {
    this.handleSelectedButton(e.id);
  }

  handleSelectedButton(id) {
    this.game.sounds.checkAudioContext();
    if (!this.enabled || this.screenIsRotated) {
      console.info('HUD DISABLED : ignoring button', id);
      return;
    }
    // console.info('>> handleSelectedButton', id);
    switch (id) {
      case 'btn_pause':
        this.game.track(AppTrackingEvents.GAME_PAUSE);
        this.game.controller.pauseGame();
        break;
      case 'btn_levelend_continue':
        this.configure({ id: Hud.EMPTY });
        this.game.controller.nextLevel();
        break;
      case 'btn_paused_continue':
        this.game.track(AppTrackingEvents.GAME_RESUME);
        this.configure({ id: Hud.PLAYING });
        this.game.controller.resumeGame();
        break;
      case 'btn_paused_restart':
        this.configure({ id: Hud.EMPTY });
        this.game.controller.restartGame();
        this.game.track(AppTrackingEvents.GAME_RESTART);
        break;
      case 'btn_home':
        this.game.track(AppTrackingEvents.GAME_EXIT);
        this.game.controller.quitGame();
        break;
      case 'btn_help':
        this.game.track(AppTrackingEvents.VIEW_SCREEN_INSTRUCTIONS);
        this.showInstructions();
        break;
      case 'btn_sound': {
        this.game.track(this.game.controller.uiModel.getIsMuted() ? AppTrackingEvents.AUDIO_ON : AppTrackingEvents.AUDIO_OFF);
        this.game.controller.uiModel.toggleAudio();
        break;
      }
      default:
    }
  }

  /**
   * state stack
   */
  saveState(state) {
    if (state) {
      this.previousStates.push({ ...state });
    }
  }

  retrievePreviousState() {
    const previousState = this.previousStates.pop();
    return previousState || null;
  }

  /*
  ====================================================================================
    CLEANUP
  ====================================================================================
  */
  destroy(destroyChildren = true, soft) {
    super.destroy(true);
  }
}

Hud.EMPTY = 'EMPTY';
Hud.WELCOME = 'WELCOME';
Hud.PAUSE = 'PAUSE';
Hud.CREDITS = 'CREDITS';
Hud.PLAYING = 'PLAYING';
Hud.LEVELEND = 'LEVELEND';
Hud.GAMEEND = 'GAMEEND';
Hud.CUTSCENE = 'GAMEEND';
Hud.STATES = {
  EMPTY: [],
  WELCOME: ['help', 'sound'],
  PAUSE: ['back', 'sound'],
  CREDITS: ['home', 'sound'],
  PLAYING: ['pause', 'sound'],
  LEVELEND: ['home', 'sound'],
  GAMEEND: ['home', 'sound'],
  GAMEOVER: ['home', 'sound'],
  CUTSCENE: ['sound'],
  GAMEOVER_BILLY: ['home', 'sound'],
};

export default Hud;
